import IpubMenusItem from '../menus/src/item'

/* istanbul ignore next */
IpubMenusItem.install = function(Vue) {
  Vue.component(IpubMenusItem.name, IpubMenusItem)
}

export default IpubMenusItem
